export function getSubscribeReferralURL() {
  return `${process.env.SUBSCRIBE_URL}?coupon=MAY2026` || '';
}
